import { applyMiddleware, createStore } from 'redux'
import thunk from 'redux-thunk'
import { GET_INFO } from './actions'
// import firebase from 'firebase/app'
// import 'firebase/database'

const rootReducer=(state={},action)=>{
  if (action.type===GET_INFO){
    return {data:action.data}
  }
  return state
}

export default createStore(rootReducer ,applyMiddleware(thunk))
